/* Sun Potion — gentle scroll reveal: sections below the fold fade up 12px / 400ms, once.
   Only sections that start below the first viewport are touched (nothing above the fold, so no LCP/CLS impact;
   transform/opacity never shift layout). Off entirely under prefers-reduced-motion or without IntersectionObserver. */
(function () {
  if (window.__spReveal) return;
  window.__spReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });

  function arm(scope) {
    var fold = window.innerHeight;
    Array.prototype.forEach.call((scope || document).querySelectorAll('main .shopify-section'), function (el) {
      if (el.classList.contains('sp-reveal') || el.offsetHeight === 0) return;
      if (el.getBoundingClientRect().top < fold) return;
      el.classList.add('sp-reveal');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { arm(); });
  else arm();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.classList.add('is-in');
  });
})();
